export const officialLinks = {
  homepage: 'https://lexfridman.com',
  podcastWebsite: 'https://lexfridman.com/podcast/',
  youtubePlaylist:
    'https://www.youtube.com/playlist?list=PLrAXtmErZgOdP_8GztsuKi9nrraNbKKp4',
  applePodcasts:
    'https://podcasts.apple.com/us/podcast/lex-fridman-podcast/id1434243584/',
  googlePodcasts:
    'https://podcasts.google.com/feed/aHR0cHM6Ly9sZXhmcmlkbWFuLmNvbS9mZWVkL3BvZGNhc3Qv',
  spotify: 'https://open.spotify.com/show/2MAi0BvDc6GTFvKFPXnkCL/',
  lexfridmanYoutube:
    'https://www.youtube.com/channel/UCSHZKyawb77ixDdsGog4iWA/',
  lexclipsYoutube: 'https://www.youtube.com/channel/UCJIfeSCssxSC_Dhc5s7woww/',
  reddit: 'https://www.reddit.com/r/lexfridman/',
  rss: 'https://lexfridman.com/feed/podcast/',
  patreon: 'https://www.patreon.com/lexfridman',
  redditUsername: 'https://www.reddit.com/user/lexfridman/',
  twitterUsername: 'https://twitter.com/LexFridman/',
  instagramUsername: 'https://www.instagram.com/lexfridman/',
  githubUsername: 'https://github.com/lexfridman',
  linkedinUsername: 'https://www.linkedin.com/in/lexfridman/',
  facebookUsername: 'https://www.facebook.com/lexfridman/',
  tiktokUsername: 'https://tiktok.com/@lexfridman/',
};
